import React, { useEffect, useState } from "react";
import { Button, Container, Form } from "react-bootstrap";
import "../newsLetter/newsletter.css";
import "../newsLetter/newslettermedia.css";
import { ErrorMessage } from "@hookform/error-message";
import { useForm } from "react-hook-form";
import { regex } from "utils/constants/regexVariables";
import { validationMessage } from "utils/constants/validationMessage";
import { useDispatch } from "react-redux";
import { GET_SUBSCRIPTION } from "store/Action/HomeAction";
import Loader from "components/shared/Loader/Loader";
import AlertMessage from "components/AlertMessage/AlertMessage";

const NewsLetter = () => {
  const dispatch = useDispatch();
  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
    watch,
    clearErrors,
  } = useForm();

  //ALL STATE
  const [subscribeValue, setSubscribeValue] = useState("");
  const [loader, setLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null)
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (!subscribeValue) {
      clearErrors();
    }
  }, [subscribeValue]);

  const onSubmit = async (data) => {
    const result = { customers_email_address: data?.subscribe };
    dispatch(
      GET_SUBSCRIPTION(result, (grpResponse, loading, grpError, errObj) => {
        if(grpError){
          setOpen(grpError)
          setErrorMessage(errObj)
        }
        setLoader(loading);
        !grpError && setValue("subscribe", "");
      })
    );
  };

  return (
    <div>
      <section className="newsletter-sec bg-light">
        <Container>
          <div className="content-wrapper">
            <div className="content">
              <h1 className="mb-sm-4 mb-3">Subscribe to Our Newsletter</h1>
            </div>
            {
                  errorMessage &&
                  <AlertMessage
                    severity="error"
                    icon={false}
                    message={errorMessage?.response?.data?.error}
                    isOpen={open}
                    onClose={handleClose}
                    className={'mb-3'}
                    autoCloseDuration={3000}
                  />
                }
            {/* <button onClick={() => clearError()}>clear error</button> */}

            <div className="banner-input-sec">
              <Form
                className="position-relative"
                onSubmit={handleSubmit(onSubmit)}
                noValidate
                autoComplete="off"
              >
                <div className="position-relative ">
                  <Form.Control
                    type="text"
                    // autoFocus={true}
                    name="subscribe"
                    placeholder="Email address"
                    {...register("subscribe", {
                      required: validationMessage.enterEmail,
                      pattern: {
                        value: regex.regEmail,
                        message: validationMessage.validEmail,
                      },
                    })}
                    onChange={(e) => setSubscribeValue(e.target.value)}
                  />

                  <Button
                    type="submit"
                    className="position-absolute end-0 top-0 bottom-0 search-btn "
                    disabled={loader}
                    style={
                      loader ? { cursor: "not-allowed" } : { cursor: "pointer" }
                    }
                  >
                    <span className="d-flex justify-content-center align-item-center">
                      Subscribe
                      {loader && (
                        <Loader
                          Style={{
                            // height: "30px",
                            // width: "30px",
                            marginLeft: "20px",
                          }}
                          classes="widththirty"

                        />
                      )}
                    </span>
                  </Button>
                </div>

                <ErrorMessage
                  errors={errors}
                  name="subscribe"
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default NewsLetter;
